module.exports = __webpack_public_path__ + "img/prevDamagenotice.619a4aeb.jpeg";